import React from 'react';
import { Colors } from 'react-native-paper';
import { Trans } from '@lingui/macro';
import styled from 'styled-components/native';

import { Subtitle2 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';
import { Business } from '@src/types';

import BusinessCard from './/BusinessCard';

type Props = {
  item: Business;
};

const Container = styled.View`
  margin-end: ${padding / 2}px;
  overflow: hidden;
`;

const Label = styled(Subtitle2)`
  transform: rotate(45deg);
  position: absolute;
  top: 10px;
  left: -30px;
  color: ${Colors.white};
  width: 100px;
  height: 18px;
  background-color: ${({ theme }) => theme.colors.primary};
  text-align: center;
  text-align-vertical: center;
`;

const Component: React.FC<Props> = ({ item }) => {
  return (
    <Container>
      <BusinessCard item={item} />
      <Label>
        <Trans>Start</Trans>
      </Label>
    </Container>
  );
};

Component.displayName = 'StartBusinessCard';

export default React.memo(Component);
